import React from "react";
import { GroupProps } from "./GroupProps";
import FilterGroup from "./FilterGroup";

const PartsFilter = ({
  groups,
  toggleCollapsed,
  groupsWithMultipleSelections,
  prefetch,
}: GroupProps) => (
  <>
    {groups.map((group) => (
      <FilterGroup
        key={`partsFilter-${group.groupNameEncoded}`}
        group={group}
        toggleCollapsed={toggleCollapsed}
        groupsWithMultipleSelections={groupsWithMultipleSelections}
        data-testid="PartsFilter"
        filterText="parts"
        prefetch={prefetch}
      />
    ))}
  </>
);

export default PartsFilter;
